import React from "react";
import './BannerIntroduce.css';
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";

function BannerIntroduce(props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    return (
            <div className="BannerIntroduce">
            <div className="BannerIntroduceRight">
                <div className="BannerIntroduceTitle">
                    <TextSource ArrIndex= 'index0130'>Introducing Innovative Solutions</TextSource>
                    <br/>
                    <TextSource ArrIndex= 'index0135'>for Better Experience</TextSource>
                </div>
                <div className="BannerIntroduceText">
                    <ul>
                        <li><TextSource ArrIndex= 'index0140'>BEST BID </TextSource> & <TextSource ArrIndex= 'index0145'>OFFER TECHNOLOGY</TextSource>&  </li>
                        <li><TextSource ArrIndex= 'index0150'>MT4</TextSource> & <TextSource ArrIndex= 'index0155'>MOBIUS SOFTWARE</TextSource> & </li>
                        <li><TextSource ArrIndex= 'index0160'>STAY CONNECTED, ENJOY MOBILITY</TextSource></li>
                    </ul>
                    <div className="BannerIntroduceButton ButtonOut">
                        <ChangeLink to={'/about'} lang={props.lang} style={{textDecoration: 'none'}}>
                            <div className='ButtonYellow'>
                                <TextSource ArrIndex= 'index0165'>FIND OUT MORE</TextSource>
                            </div>
                        </ChangeLink>
                    </div>
                </div>

            </div>
            </div>
    )}

export default BannerIntroduce





